module.exports = __webpack_public_path__ + "img/jpg-xiangqingmulu@2x.d78a992b.png";